import { z } from 'zod/v4';
import { InteractionType } from '../interactions/index.js';
import { TemplateType } from '../templates/index.js';
export var SessionEventCategory;
(function (SessionEventCategory) {
    SessionEventCategory["Interactions"] = "INTERACTIONS";
})(SessionEventCategory || (SessionEventCategory = {}));
export const SessionEventSchema = z
    .object({
    id: z.uuid(),
    sessionId: z.uuid(),
    sessionSeq: z.uint32(),
    tabId: z.uuid(),
    timestamp: z.int(),
    eventCategory: z.enum(SessionEventCategory),
})
    .and(z.union([
    z.object({
        eventType: z.literal('generated_interaction_suggestion'),
        details: z.object({
            caseId: z.uuid(),
            replyingTo: z.uuid().optional(),
            templateType: z.enum(TemplateType),
            interactionType: z.enum(InteractionType),
            prompt: z.string().optional(),
        }),
    }),
    z.object({
        eventType: z.literal('categorized_message'),
        details: z.object({
            interactionId: z.uuid(),
            category: z.uuid(),
        }),
    }),
    z.object({
        eventType: z.literal('uncategorized_message'),
        details: z.object({
            interactionId: z.uuid(),
            category: z.uuid(),
        }),
    }),
    z.object({
        eventType: z.literal('edited_interaction'),
        details: z.object({
            caseId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
    z.object({
        eventType: z.literal('deleted_interaction_content'),
        details: z.object({
            caseId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
    z.object({
        eventType: z.literal('changed_interaction_template'),
        details: z.object({
            caseId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
    z.object({
        eventType: z.literal('submitted_interaction'),
        details: z.object({
            caseId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
    z.object({
        eventType: z.literal('previewed_interaction'),
        details: z.object({
            caseId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
    z.object({
        eventType: z.literal('deleted_interaction'),
        details: z.object({
            interactionId: z.uuid(),
            interactionType: z.enum(InteractionType),
        }),
    }),
]));
export const sessionEventTypeCategories = {
    categorized_message: SessionEventCategory.Interactions,
    uncategorized_message: SessionEventCategory.Interactions,
    generated_interaction_suggestion: SessionEventCategory.Interactions,
    edited_interaction: SessionEventCategory.Interactions,
    deleted_interaction_content: SessionEventCategory.Interactions,
    submitted_interaction: SessionEventCategory.Interactions,
    previewed_interaction: SessionEventCategory.Interactions,
    changed_interaction_template: SessionEventCategory.Interactions,
    deleted_interaction: SessionEventCategory.Interactions,
};
//# sourceMappingURL=index.js.map